import { Spinner } from "@agentsaas/ui";
import { useT } from "../app/i18n";

export function Loading() {
  const { t } = useT();
  return (
    <div className="center-fill">
      <Spinner label={t("common.loading")} />
    </div>
  );
}
